import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';

import { toList } from '../toList';

export const functionNamesById = createSelector(getOrganization, (organization) => {
  const result: { [uuid: string]: string } = {};

  if (organization) {
    toList(organization.functionsById).forEach((e) => {
      result[e.uuid] = e.name !== undefined ? e.name : '';
    });
  }
  return result;
});
